import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { userReducer } from './user.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('user', userReducer) // Register the feature with the name 'user'
  ]
})
export class UserModule { }
